import { useState } from 'react';
import api from '../../services/api';

export default function AddCoachingCenterModal({ isOpen, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    contact_email: '',
    contact_phone: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await api.createCoachingCenter(formData);
      onSuccess();
      onClose();
      setFormData({ name: '', location: '', contact_email: '', contact_phone: '' });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4">
        <div className="p-6 border-b border-teacher-border">
          <h2 className="text-xl font-semibold text-teacher-text-primary">Add Coaching Center</h2>
          <p className="text-sm text-teacher-text-secondary mt-1">Top-level entity that owns teachers and batches.</p>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-red-700 text-sm">{error}</div>
          )}
          <div>
            <label className="block text-sm font-medium text-teacher-text-primary mb-1">
              Name <span className="text-red-500">*</span>
            </label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} required
              className="w-full px-3 py-2 border border-teacher-border-strong rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
              placeholder="Shetty Classes" />
          </div>
          <div>
            <label className="block text-sm font-medium text-teacher-text-primary mb-1">Location</label>
            <input type="text" name="location" value={formData.location} onChange={handleChange}
              className="w-full px-3 py-2 border border-teacher-border-strong rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
              placeholder="Bangalore" />
          </div>
          <div>
            <label className="block text-sm font-medium text-teacher-text-primary mb-1">Contact Email</label>
            <input type="email" name="contact_email" value={formData.contact_email} onChange={handleChange}
              className="w-full px-3 py-2 border border-teacher-border-strong rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
              placeholder="director@center.com" />
          </div>
          <div>
            <label className="block text-sm font-medium text-teacher-text-primary mb-1">Contact Phone</label>
            <input type="tel" name="contact_phone" value={formData.contact_phone} onChange={handleChange}
              className="w-full px-3 py-2 border border-teacher-border-strong rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
              placeholder="+91XXXXXXXXXX" />
          </div>
          <div className="flex gap-3 pt-4">
            <button type="button" onClick={onClose} disabled={loading}
              className="flex-1 px-4 py-2 border border-teacher-border-strong rounded-lg text-teacher-text-primary hover:bg-teacher-bg">
              Cancel
            </button>
            <button type="submit" disabled={loading}
              className="flex-1 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50">
              {loading ? 'Creating...' : 'Create Center'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
